import { render, staticRenderFns } from "./actDetail.vue?vue&type=template&id=094068ef&scoped=true&"
import script from "./actDetail.vue?vue&type=script&lang=ts&"
export * from "./actDetail.vue?vue&type=script&lang=ts&"
import style0 from "./actDetail.vue?vue&type=style&index=0&id=094068ef&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "094068ef",
  null
  
)

export default component.exports